<!-- <div class="row">
  <div class="col-sm-6 col-lg-3 pb-4">
    <jni-dashboard-cards
      cardTitle="CDI's"
      [cardValue]="cdiCount"
    ></jni-dashboard-cards>
  </div>
  <div class="col-sm-6 col-lg-2 pb-4">
    <jni-dashboard-cards
      [colorCode]="cardClass[0]"
      cardTitle="Invoice Preview"
      [cardValue]="invoicePreviewCount"
      momValue="-121"
    ></jni-dashboard-cards>
  </div>
  <div class="col-sm-6 col-lg-2 pb-4">
    <jni-dashboard-cards
      [colorCode]="cardClass[2]"
      cardTitle="Pending Chargebacks"
      [cardValue]="chargebackCount"
      momValue="-1"
    ></jni-dashboard-cards>
  </div>
  <div class="col-sm-6 col-lg-2 pb-4">
    <jni-dashboard-cards
      [colorCode]="cardClass[1]"
      cardTitle="Disputed Invoices"
      [cardValue]="disputedInvoicesCount"
    ></jni-dashboard-cards>
  </div>
  <div class="col-sm-6 col-lg-3 pb-4">
    <jni-dashboard-cards
      [colorCode]="cardClass[1]"
      cardTitle="Expiring Protection"
      [cardValue]="expiringDaysCount"
    ></jni-dashboard-cards>
  </div>
</div> -->
<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <div class="col-lg-6 dashboard-table dashboard-table-head mb-3">
      <p-card header="">
        <jni-dashboard-tables
          [columns]="qr1.columns || []"
          [data]="qr1.data || []"
          [heading]="qr1.heading || ''"
          [redirectCompleteLink]="qr1.redirectCompleteLink || ''"
          [showSmallLoader]="qr1.showSmallLoader || false"
          [displayFooter]="qr1.displayFooter || false"
          [merchTotal]="qr1.merchTotal || 0"
          [freightTotal]="qr1.freightTotal || 0"
          [taxTotal]="qr1.taxTotal || 0"
          [invTotalSum]="qr1.invTotalSum || 0"
          [dasbhoardReportState]="qr1.heading || ''"
          [qR2Reports]="qR2Reports"
          [qr3Response]="qr3Response"
          [totalOutstanding]="totalOutstanding || 0"
          [isQr1YearOverYearDashboardReport]="isQr1YearOverYearDashboardReport"
          (toggleModalForTables)="toggleModalForTables($event)"
          (openModalEvent)="showModuleModal($event)"></jni-dashboard-tables>
      </p-card>
    </div>

    <div class="col-lg-6 dashboard-table dashboard-table-head mb-3">
      <p-card header="">
        <jni-dashboard-tables
          [columns]="qr2.columns || []"
          [data]="qr2.data || []"
          [heading]="qr2.heading || ''"
          [redirectCompleteLink]="qr2.redirectCompleteLink || ''"
          [showSmallLoader]="qr2.showSmallLoader || false"
          [displayFooter]="qr2.displayFooter || false"
          [merchTotal]="qr2.merchTotal || 0"
          [freightTotal]="qr2.freightTotal || 0"
          [taxTotal]="qr2.taxTotal || 0"
          [invTotalSum]="qr2.invTotalSum || 0"
          [dasbhoardReportState]="qr2.heading || ''"
          (toggleModalForTables)="toggleModalForTables($event)"
          [qR2Reports]="qR2Reports"
          [qr3Response]="qr3Response"
          [totalOutstanding]="totalOutstanding || 0"
          [isQr2YearOverYearDashboardReport]="isQr2YearOverYearDashboardReport"
          (openModalEvent)="showModuleModal($event)"></jni-dashboard-tables>
      </p-card>
    </div>
    <div class="col-lg-6 dashboard-table dashboard-table-head mb-3">
      <p-card header="">
        <jni-dashboard-tables
          [columns]="qr3.columns || []"
          [data]="qr3.data || []"
          [heading]="qr3.heading || ''"
          [redirectCompleteLink]="qr3.redirectCompleteLink || ''"
          (toggleModalForTables)="toggleModalForTables($event)"
          [showSmallLoader]="qr3.showSmallLoader || false"
          [displayFooter]="qr3.displayFooter || false"
          [merchTotal]="qr3.merchTotal || 0"
          [freightTotal]="qr3.freightTotal || 0"
          [taxTotal]="qr3.taxTotal || 0"
          [invTotalSum]="qr3.invTotalSum || 0"
          [dasbhoardReportState]="qr3.heading || ''"
          [qR2Reports]="qR2Reports"
          [qr3Response]="qr3Response"
          [totalOutstanding]="totalOutstanding || 0"
          [isQr3YearOverYearDashboardReport]="isQr3YearOverYearDashboardReport"
          (openModalEvent)="showModuleModal($event)"></jni-dashboard-tables>
      </p-card>
    </div>
    <div class="col-lg-6 dashboard-table dashboard-table-head mb-3">
      <p-card header="">
        <jni-dashboard-tables
          [columns]="qr4.columns || []"
          [data]="qr4.data || []"
          [heading]="qr4.heading || ''"
          (toggleModalForTables)="toggleModalForTables($event)"
          [redirectCompleteLink]="qr4.redirectCompleteLink || ''"
          [showSmallLoader]="qr4.showSmallLoader || false"
          [displayFooter]="qr4.displayFooter || false"
          [merchTotal]="qr4.merchTotal || 0"
          [freightTotal]="qr4.freightTotal || 0"
          [taxTotal]="qr4.taxTotal || 0"
          [invTotalSum]="qr4.invTotalSum || 0"
          [dasbhoardReportState]="qr4.heading || ''"
          [qR2Reports]="qR2Reports"
          [qr3Response]="qr3Response"
          [totalOutstanding]="totalOutstanding || 0"
          [isQr4YearOverYearDashboardReport]="isQr4YearOverYearDashboardReport"
          (openModalEvent)="showModuleModal($event)"></jni-dashboard-tables>
      </p-card>
    </div>
  </div>
</div>

<!-- Faizan Rehman UI Changes
<div class="col-lg-12 content-scroll-screen parent">
  <div class="row child">
    <div class="col-lg-6 dashboard-table dashboard-table-head">
      <p-card header="">
        <span class="d-flex justify-content-between align-items-center mb-3">
          <span><h1 class="mb-0">Ready To Bill Report</h1></span>
          <span
            ><a href="javascript:;" class="text-decoration-none"
              >View Compelete list</a
            ></span
          >
        </span>

        <p-table
          [value]="products"
          stripedRows
          [scrollable]="true"
          [scrollHeight]="scrollHeight"
          selectionMode="single">
          <ng-template #header>
            <tr>
              <th>Account</th>
              <th>Name</th>
              <th>Available Credit</th>
              <th>Address</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr>
              <td class="table-active-text">{{ product.code }}</td>
              <td class="table-gray-text">{{ product.name }}</td>
              <td class="table-active-text">{{ product.category }}</td>
              <td class="table-gray-text">{{ product.quantity }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

    <div class="col-lg-6 dashboard-table dashboard-table-head">
      <p-card header="">
        <span class="d-flex justify-content-between align-items-center mb-3">
          <span><h1 class="mb-0">Ready To Bill Report</h1></span>
          <span
            ><a href="javascript:;" class="text-decoration-none"
              >View Compelete list</a
            ></span
          >
        </span>

        <p-table
          [value]="products"
          stripedRows
          [scrollable]="true"
          [scrollHeight]="scrollHeight"
          selectionMode="single">
          <ng-template #header>
            <tr>
              <th>Account</th>
              <th>Name</th>
              <th>Available Credit</th>
              <th>Address</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr>
              <td class="table-active-text">{{ product.code }}</td>
              <td class="table-gray-text">{{ product.name }}</td>
              <td class="table-active-text">{{ product.category }}</td>
              <td class="table-gray-text">{{ product.quantity }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </div>

  <div class="row mt-3 child">
    <div class="col-lg-6 dashboard-table dashboard-table-head">
      <p-card header="">
        <span class="d-flex justify-content-between align-items-center mb-3">
          <span><h1 class="mb-0">Ready To Bill Report</h1></span>
          <span
            ><a href="javascript:;" class="text-decoration-none"
              >View Compelete list</a
            ></span
          >
        </span>

        <p-table
          [value]="products"
          stripedRows
          [scrollable]="true"
          [scrollHeight]="scrollHeight"
          selectionMode="single">
          <ng-template #header>
            <tr>
              <th>Account</th>
              <th>Name</th>
              <th>Available Credit</th>
              <th>Address</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr>
              <td class="table-active-text">{{ product.code }}</td>
              <td class="table-gray-text">{{ product.name }}</td>
              <td class="table-active-text">{{ product.category }}</td>
              <td class="table-gray-text">{{ product.quantity }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>

    <div class="col-lg-6 dashboard-table dashboard-table-head">
      <p-card header="">
        <span class="d-flex justify-content-between align-items-center mb-3">
          <span><h1 class="mb-0">Ready To Bill Report</h1></span>
          <span
            ><a href="javascript:;" class="text-decoration-none"
              >View Compelete list</a
            ></span
          >
        </span>

        <p-table
          [value]="products"
          stripedRows
          [scrollable]="true"
          [scrollHeight]="scrollHeight"
          selectionMode="single">
          <ng-template #header>
            <tr>
              <th>Account</th>
              <th>Name</th>
              <th>Available Credit</th>
              <th>Address</th>
            </tr>
          </ng-template>
          <ng-template #body let-product>
            <tr>
              <td class="table-active-text">{{ product.code }}</td>
              <td class="table-gray-text">{{ product.name }}</td>
              <td class="table-active-text">{{ product.category }}</td>
              <td class="table-gray-text">{{ product.quantity }}</td>
            </tr>
          </ng-template>
        </p-table>
      </p-card>
    </div>
  </div>
</div>


-->
<jni-modal-stacker *ngIf="qr1DisplayModal" [displayModal]="qr1DisplayModal">
  <h1 class="panelHeading">Chargeback Aging Report Listing</h1>
  <div class="panelBody">
    <jni-qr1-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="
        toggleModalForTables({ type: 'qr1DisplayModal', status: false })
      "></jni-qr1-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker *ngIf="qr2DisplayModal" [displayModal]="qr2DisplayModal">
  <h1 class="panelHeading">Orders Written this month Listing</h1>
  <div class="panelBody">
    <jni-qr2-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="
        toggleModalForTables({ type: 'qr2DisplayModal', status: false })
      "></jni-qr2-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker *ngIf="qr3DisplayModal" [displayModal]="qr3DisplayModal">
  <h1 class="panelHeading">Invoices Posted this month Listing</h1>
  <div class="panelBody">
    <jni-qr3-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="
        toggleModalForTables({ type: 'qr3DisplayModal', status: false })
      ">
    </jni-qr3-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker *ngIf="qr4DisplayModal" [displayModal]="qr4DisplayModal">
  <h1 class="panelHeading">Open orders by In Hands Date Listing</h1>
  <div class="panelBody">
    <jni-qr4-complete
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="
        toggleModalForTables({ type: 'qr4DisplayModal', status: false })
      "></jni-qr4-complete>
  </div>
</jni-modal-stacker>

<jni-modal-stacker *ngIf="qr6DisplayModal" [displayModal]="qr6DisplayModal">
  <h1 class="panelHeading">Ready To Bill Report</h1>

  <div class="panelBody">
    <jni-ready-to-bill
      [fromDashboard]="true"
      (closeEvent)="
        toggleModalForTables({ type: 'qr6DisplayModal', status: false })
      "></jni-ready-to-bill>
  </div>
</jni-modal-stacker>
<jni-modal-stacker *ngIf="qr5DisplayModal" [displayModal]="qr5DisplayModal">
  <h1 class="panelHeading">AR Aging Dashboard Report</h1>

  <div class="panelBody">
    <jni-ar-aging-details-report
      (scrollHiddenStatus)="scrollHiddenStatus()"
      [fromDashboard]="true"
      (closeEvent)="
        toggleModalForTables({ type: 'qr5DisplayModal', status: false })
      "></jni-ar-aging-details-report>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  class="modal-header-sticky"
  *ngIf="orderDisplayModal"
  [displayModal]="orderDisplayModal"
  (closeEvent)="closeModalForSaleOrder()">
  <h1 class="panelHeading">Order Summary</h1>
  <div class="panelBody">
    <jni-order-summary
      [isModal]="true"
      [saleOrderIdFromModal]="saleOrderId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeOrderSummaryModalEvent)="
        closeModalForSaleOrder()
      "></jni-order-summary>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="clientDisplayModal"
  [displayModal]="clientDisplayModal"
  (closeEvent)="closeModalForClient()">
  <h1 class="panelHeading">Client Summary</h1>
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientId"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      (closeEvent)="closeModalForClient()"
      [isModal]="true">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="samplePODisplayModal"
  [displayModal]="samplePODisplayModal"
  (closeEvent)="closeModalForSamplePO()">
  <h1 class="panelHeading">SamplePO Listing</h1>
  <div class="panelBody">
    <jni-samplepo-listing
      [ponumber]="ponumber"
      (scrollHiddenStatus)="scrollHiddenStatus()"
      [isModal]="true"
      (closeModalEvent)="closeModalForSamplePO()">
    </jni-samplepo-listing>
  </div>
</jni-modal-stacker>
